export const kubernetesLiveResourceHealthStatusCodes = ["Degraded", "Healthy", "Available", "Progressing", "Unknown", "Missing", "Suspended"] as const;
export type KubernetesLiveResourceHealthStatusCode = (typeof kubernetesLiveResourceHealthStatusCodes)[number];
export const kubernetesLiveResourceSyncStatusCodes = ["InSync", "OutOfSync"] as const;
export type KubernetesLiveResourceSyncStatusCode = (typeof kubernetesLiveResourceSyncStatusCodes)[number];
